module.exports = __webpack_public_path__ + "img/s8.efa2a95d.png";